import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

import cn from './styles.local.less';

export default class Section extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    titleClassName: PropTypes.string,
    children: PropTypes.node,
    title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  };

  renderTitle() {
    const { title, titleClassName } = this.props;

    return title ? (
      <div className={cns(cn.title, titleClassName)}>
        {title}
        <hr className={cn.hr} />
      </div>
    ) : null;
  }

  render() {
    const { className, children } = this.props;

    return (
      <div className={cns(cn.root, className)}>
        {this.renderTitle()}
        {children}
      </div>
    );
  }
}
